import * as yup from 'yup';
import { Row, RenderConfig, NumberInput, AsyncSelect, SelectInput } from 'commons-ui';

export const FORM_FIELD_KEYS = {
	VERSION_NUMBER: 'versionNumber',
	CONTROL_VERSION_NUMBER: 'controlVersionNumber',
	TEST_PERCENTAGE: 'testPercentage',
	WEBSITE_NAME: 'websiteName'
};

export const validationSchema = yup.object().shape({
	versionNumber: yup.number().required('Test Version number is a required field'),
	controlVersionNumber: yup.number().required('Control Version number is a required field'),
	testPercentage: yup.number().required('Test Percentage number is a required field'),
	websiteName: yup.string().required('Website is a required field')
});

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.VERSION_NUMBER]: new RenderConfig()
		.setName('versionNumber')
		.setLabel('Test Version Number')
		.setRenderer(AsyncSelect)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true }),
	[FORM_FIELD_KEYS.CONTROL_VERSION_NUMBER]: new RenderConfig()
		.setName('controlVersionNumber')
		.setLabel('Control Version Number')
		.setRenderer(AsyncSelect)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true }),
	[FORM_FIELD_KEYS.TEST_PERCENTAGE]: new RenderConfig()
		.setName('testPercentage')
		.setLabel('Test Percentage')
		.setRenderer(NumberInput)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true }),
	[FORM_FIELD_KEYS.WEBSITE_NAME]: new RenderConfig()
		.setName('websiteName')
		.setLabel('Website Name')
		.setRenderer(SelectInput)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true })
};

export const FORM_LAYOUT_CONFIG = [
	new Row(FORM_FIELD_KEYS.VERSION_NUMBER),
	new Row(FORM_FIELD_KEYS.CONTROL_VERSION_NUMBER),
	new Row(FORM_FIELD_KEYS.TEST_PERCENTAGE),
	new Row(FORM_FIELD_KEYS.WEBSITE_NAME)
];
